/**
 * Romanian
 */
export { default as navbarRo } from "./ro/navbar.json";
export { default as achievementBoxRo } from "./ro/achievementBox.json";
export { default as privacySettingsRo } from "./ro/privacySettings.json";
export { default as reelsRo } from "./ro/reels.json";
export { default as marketplaceRo } from "./ro/marketplace.json";
export { default as profileRo } from "./ro/profile.json";
export { default as commonRo } from "./ro/common.json";
export { default as courseRo } from "./ro/course.json";
export { default as exerciseRo } from "./ro/exercise.json";
export { default as dropzoneValidationRo } from "./ro/dropzoneValidation.json";
export { default as searchRo } from "./ro/search.json";
export { default as walletRo } from "./ro/wallet.json";
export { default as resendEmailRo } from "./ro/resendEmail.json";
export { default as nftCardRo } from "./ro/nftCard.json";
export { default as profileEditRo } from "./ro/profileEdit.json";
export { default as chatRo } from "./ro/chat.json";
export { default as transferAssetRo } from "./ro/transferAsset.json";
export { default as walletTransferCardRo } from "./ro/walletTransferCard.json";
export { default as storeRo } from "./ro/store.json";
export { default as nftVoucherCardRo } from "./ro/nftVoucherCard.json";
export { default as lastSeenCourseCardRo } from "./ro/lastSeenCourseCard.json";
export { default as infoScreenRo } from "./ro/infoScreen.json";
export { default as liveStreamingRo } from "./ro/liveStreaming.json";
export { default as webinarRo } from "./ro/webinar.json";
export { default as streamRo } from "./ro/stream.json";
export { default as landingRo } from "./ro/landing.json";
export { default as countdownRo } from "./ro/countdown.json";
export { default as notesRo } from "./ro/notes.json";
export { default as navigationRo } from "./ro/navigation.json";
export { default as contactRo } from "./ro/contact.json";
export { default as notificationsRo } from "./ro/notifications.json";
export { default as restrictedAccessScreenRo } from "./ro/restrictedAccessScreen.json";
export { default as crmRo } from "./ro/crm.json";
export { default as crmCampaignReportRo } from "./ro/crmCampaignReport.json";
export { default as dynamicDateHourPickerRo } from "./ro/dynamicDateHourPicker.json";
export { default as calendarRo } from "./ro/calendar.json";
export { default as gamificationRo } from "./ro/gamification.json";
export { default as crmOrderReportRo } from "./ro/crmOrderReport.json";
export { default as contractRo } from "./ro/contract.json";
export { default as profileBankAccountRo } from "./ro/profileBankAccount.json";
export { default as recomandationFormRo } from "./ro/recomandationForm.json";
export { default as prizeRo } from "./ro/prize.json";
export { default as freeTrialRo } from "./ro/freeTrial.json";
export { default as bugReportRo } from "./ro/bugReport.json";
export { default as reservationRo } from "./ro/reservation.json";

/**
 * English
 */
export { default as navbarEn } from "./en/navbar.json";
export { default as achievementBoxEn } from "./en/achievementBox.json";
export { default as privacySettingsEn } from "./en/privacySettings.json";
export { default as reelsEn } from "./en/reels.json";
export { default as marketplaceEn } from "./en/marketplace.json";
export { default as profileEn } from "./en/profile.json";
export { default as commonEn } from "./en/common.json";
export { default as courseEn } from "./en/course.json";
export { default as exerciseEn } from "./ro/exercise.json";
export { default as dropzoneValidationEn } from "./en/dropzoneValidation.json";
export { default as searchEn } from "./en/search.json";
export { default as walletEn } from "./en/wallet.json";
export { default as resendEmailEn } from "./en/resendEmail.json";
export { default as nftCardEn } from "./en/nftCard.json";
export { default as profileEditEn } from "./en/profileEdit.json";
export { default as chatEn } from "./en/chat.json";
export { default as transferAssetEn } from "./en/transferAsset.json";
export { default as walletTransferCardEn } from "./en/walletTransferCard.json";
export { default as storeEn } from "./en/store.json";
export { default as nftVoucherCardEn } from "./en/nftVoucherCard.json";
export { default as lastSeenCourseCardEn } from "./en/lastSeenCourseCard.json";
export { default as infoScreenEn } from "./en/infoScreen.json";
export { default as liveStreamingEn } from "./en/liveStreaming.json";
export { default as webinarEn } from "./en/webinar.json";
export { default as streamEn } from "./en/stream.json";
export { default as landingEn } from "./en/landing.json";
export { default as countdownEn } from "./en/countdown.json";
export { default as notesEn } from "./en/notes.json";
export { default as navigationEn } from "./en/navigation.json";
export { default as contactEn } from "./en/contact.json";
export { default as notificationsEn } from "./en/notifications.json";
export { default as restrictedAccessScreenEn } from "./en/restrictedAccessScreen.json";
export { default as crmEn } from "./en/crm.json";
export { default as crmCampaignReportEn } from "./en/crmCampaignReport.json";
export { default as dynamicDateHourPickerEn } from "./en/dynamicDateHourPicker.json";
export { default as calendarEn } from "./en/calendar.json";
export { default as gamificationEn } from "./ro/gamification.json"; // TODO Ovidiu, change to en Path
export { default as crmOrderReportEn } from "./en/crmOrderReport.json";
export { default as contractEn } from "./en/contract.json";
export { default as profileBankAccountEn } from "./en/profileBankAccount.json";
export { default as recomandationFormEn } from "./en/recomandationForm.json";
export { default as prizeEn } from "./en/prize.json";
export { default as freeTrialEn } from "./en/freeTrial.json";
export { default as bugReportEn } from "./en/bugReport.json";
export { default as reservationEn } from "./en/reservation.json";
